import React, { useState } from "react";
import { Calendar } from "lucide-react";

export default function ApiUsage() {
  const [dateRange, setDateRange] = useState("最近7天");

  const ranges = ["最近7天", "最近30天", "最近90天", "最近半年", "最近一年"];

  return (
    <div className="flex-1 p-6 bg-gray-50 overflow-y-auto h-[calc(100vh-56px)]">
      <div className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm mb-6">
        <h3 className="text-lg font-semibold text-gray-800 mb-6">API 用量明细</h3>
        
        <div className="flex flex-wrap items-center gap-8 text-sm">
          <div className="flex items-center gap-2">
            <span className="text-gray-500">套餐名称:</span>
            <label className="flex items-center gap-1.5 cursor-pointer">
              <input type="checkbox" className="w-4 h-4 rounded border-gray-300" />
              <span className="text-gray-700">全部</span>
            </label>
            <label className="flex items-center gap-1.5 cursor-pointer">
              <input type="checkbox" checked className="w-4 h-4 rounded border-gray-300 accent-blue-600" />
              <span className="text-gray-700 font-medium">数源·知海API体验包</span>
            </label>
          </div>

          <div className="flex items-center gap-2">
            <span className="text-gray-500">时间区间:</span>
            <div className="flex bg-gray-100 p-0.5 rounded-lg">
              {ranges.map(r => (
                <button 
                  key={r}
                  onClick={() => setDateRange(r)}
                  className={`px-3 py-1 text-xs rounded-md transition-all ${
                    dateRange === r ? "bg-blue-600 text-white shadow-sm" : "text-gray-500 hover:text-gray-700"
                  }`}
                >
                  {r}
                </button>
              ))}
            </div>
            <div className="flex items-center gap-2 ml-2 px-3 py-1.5 bg-white border border-gray-200 rounded-lg text-xs text-gray-500">
              <Calendar className="w-3.5 h-3.5" />
              <span>选择日期范围</span>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        <div className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm min-h-[300px]">
          <h4 className="text-sm font-bold text-gray-700 mb-6 flex items-center gap-2">
            <span className="w-1 h-4 bg-blue-600 rounded-full"></span>
            数据统计
          </h4>
          <div className="flex items-center gap-4 mb-4">
            <div className="p-3 bg-blue-50 rounded-xl">
              <div className="text-[10px] text-gray-400 font-medium">总调用次数</div>
              <div className="text-2xl font-bold text-gray-800">40</div>
            </div>
          </div>
          {/* 模拟图表 */}
          <div className="h-48 flex items-end gap-2 px-4 border-b border-l border-gray-100 relative">
             <div className="w-full h-full absolute inset-0 flex items-center justify-center opacity-5">
                <div className="w-full h-1 bg-blue-600 blur-sm rounded-full"></div>
             </div>
             {[5, 12, 30, 25, 10, 8, 15].map((h, i) => (
               <div key={i} className="flex-1 bg-blue-100 hover:bg-blue-200 rounded-t-sm transition-all cursor-pointer relative group" style={{ height: `${h * 4}%` }}>
                  <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-gray-800 text-white text-[10px] px-2 py-1 rounded hidden group-hover:block">
                    {h}次
                  </div>
               </div>
             ))}
          </div>
          <div className="flex justify-between mt-2 px-1 text-[10px] text-gray-400">
             <span>2026-04-15</span>
             <span>2026-04-21</span>
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm min-h-[300px]">
          <h4 className="text-sm font-bold text-gray-700 mb-6 flex items-center gap-2">
            <span className="w-1 h-4 bg-blue-600 rounded-full"></span>
            Top排行(调用次数降序)
          </h4>
          <div className="space-y-4">
            {[
              { name: "企业关键词检索", count: 100, color: "bg-blue-600" },
              { name: "企业合作关系", count: 80, color: "bg-blue-500" },
              { name: "企业基本信息", count: 75, color: "bg-blue-400" },
              { name: "企业经营状态", count: 60, color: "bg-blue-300" },
              { name: "企业属性标签", count: 45, color: "bg-blue-200" },
            ].map(item => (
              <div key={item.name} className="flex items-center gap-4">
                <span className="text-xs text-gray-600 w-24 shrink-0 truncate">{item.name}</span>
                <div className="flex-1 h-6 bg-gray-100 rounded-sm overflow-hidden">
                  <div className={`h-full ${item.color} rounded-sm transition-all duration-1000`} style={{ width: `${item.count}%` }}></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
        <table className="w-full text-left border-collapse text-xs">
          <thead className="bg-gray-50 text-gray-500 font-medium uppercase tracking-wider">
            <tr>
              <th className="px-6 py-4 border-b border-gray-100">序号</th>
              <th className="px-6 py-4 border-b border-gray-100">名称</th>
              <th className="px-6 py-4 border-b border-gray-100">分类</th>
              <th className="px-6 py-4 border-b border-gray-100">所属权益包</th>
              <th className="px-6 py-4 border-b border-gray-100">调用次数</th>
              <th className="px-6 py-4 border-b border-gray-100">扣费次数</th>
              <th className="px-6 py-4 border-b border-gray-100">操作</th>
            </tr>
          </thead>
          <tbody className="text-gray-700 divide-y divide-gray-50">
            <tr className="hover:bg-gray-50/50">
              <td className="px-6 py-4">1</td>
              <td className="px-6 py-4 font-medium text-gray-800">[58] 企业关键词检索</td>
              <td className="px-6 py-4">企业</td>
              <td className="px-6 py-4">数源·知海API体验包</td>
              <td className="px-6 py-4 font-bold">9</td>
              <td className="px-6 py-4">9</td>
              <td className="px-6 py-4">
                <button className="text-blue-600 hover:underline">查看API文档</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
